import React from 'react';
import { Tooltip } from 'react-tippy';

function setStatusDescription(roomCategory, roomCategoryName) {

var getRoomCategoryStatus = roomCategory.filter(function(room) {
    return room.name == roomCategoryName;
});


if (getRoomCategoryStatus === 'undefined') {
    return 'Status Not Set';
} else {

    switch (getRoomCategoryStatus[0].status) {
        case 0:
         return 'Inactive';
        case 1:
          return 'Active';
        default:
          return null;
      }
    }
}

export default function getSearchTableColumns(context) {
    let columns = [
        {
            id: 'roomCategory',
            Header: 'Room Category',
            accessor: (d) => {
                return d.roomCategoryName;
            }
        },
        {
            id: 'roomStstus',
            Header: 'Room Status',
            accessor: (d) => {
                return setStatusDescription(d.hotel.roomCategories, d.roomCategoryName);
            }
        },
        {
            id: 'actions',
            Header: 'Actions',
            filterable: false,
            width: 75,
            Cell: (row) => (
                <Tooltip title="Edit Inventory" position="top" animation="fade" arrow size="big" distance={15}>
                    <button
                        className="btn btn-primary btn-xs"
                        onClick={context.props.onEditClick.bind(context, row.original.id)}
                        name="btn-edit"
                        disabled={row.original.deleted}
                        id={`btn-edit-${row.original.id}`}>
                        <span className="glyphicon glyphicon-pencil" />
                    </button>
                </Tooltip>
            )
        }
    ];
    return columns;
}
